import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-10 md:py-24 bg-maternal-cream" data-id="element-164">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-maternal-beige relative overflow-hidden" data-id="element-166">
          <div className="absolute top-0 left-0 w-2 h-full bg-maternal-orange" data-id="element-167"></div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-maternal-brown" data-id="element-168">
            El problema no es que seas una mala madre ni que tu hijo sea "malo".
          </h2>

          <p className="text-xl text-maternal-lightBrown mb-6 leading-relaxed" data-id="element-169">
            El problema es que la comunicación se rompió y cada intento de
            acercarte se siente como un ataque para él.
          </p>

          <p className="text-lg text-maternal-lightBrown leading-relaxed" data-id="element-170">
            Pasas el día{' '}
            <span className="font-semibold text-maternal-orange bg-maternal-orange/10 px-2 py-1 rounded" data-id="element-171">
              caminando sobre cáscaras de huevo
            </span>
            , midiendo tus palabras para no desatar una guerra, mientras sientes
            que el vínculo se te escapa de las manos. El silencio en casa se ha
            vuelto ensordecedor y el miedo a perderlo para siempre empieza a
            quitarte el sueño.
          </p>
        </motion.div>
      </div>
    </section>;
}